<!--
BARRA DE BOTOES PARA UTILIZACAO NA DIGITACAO DE PEDIDOS, NOTAS, ETC

ITENS DO PEDIDO DE VENDA:
-  habilita os botoes conforme status do item do pedido
<bar-grid
    :options="{barPedvIt: true, stpedv: 'D'}"
    :moreActions="{ action: '', title: '', id: ? }"
    v-on:edit=""
    v-on:view=""
    v-on:cancel=""
    v-on:delete=""
    v-on:action="">
</bar-grid>

BARRA PADRAO:   barDefault: true
<bar-grid
    :options="{barDefault: true, btnView: true, btnEdit: true, btnPrint: true, btnFaturar: true}"
    :moreActions="{ action: '', title: '', id: ? }"
    v-on:edit=""
    v-on:view=""
    v-on:cancel=""
    v-on:delete=""
    v-on:action="">
</bar-grid>


BATAO MAIS ACOES:
moreActions: [
    { action: '', title: '', id: ? }
]

EVENTOS:
v-on:view
v-on:edit
v-on:action(action)

    <bar-grid
        :obj="di"
        :options="optionsGrid(di)"
        :moreActions="moreActionsGrid(di)"
        @view="handleView(di.coddi)"
        @edit="handleEdit(di.coddi)"
        @delete="handleDelete(di.coddi)"
        @action="handleAction">
    </bar-grid>

    handleAction (act, obj) {

    }

-->

<template>
    <div class="float-right">
        <div class="btn-group" v-if="options.barDefault">
            <button type="button" class="btn btn-outline-secondary btn-sm" style="margin-right: 5px"
                data-toggle="tooltip" data-placement="top" title="Alterar"
                v-if="options.btnEdit" @click="clickEdit()">
                    <i class="fa fa-pencil fa-fw"></i>
                    <span v-if="options.btnEditLabel" class="ml-1">{{ options.btnEditLabel }}</span>
            </button>
            <button type="button" class="btn btn-outline-secondary btn-sm" style="margin-right: 5px"
                data-toggle="tooltip" data-placement="top" title="Excluir"
                v-if="options.btnDelete" @click="clickDelete()">
                    <i class="fa fa-trash fa-fw"></i>
            </button>
            <button type="button" class="btn btn-outline-secondary btn-sm" style="margin-right: 5px"
                data-toggle="tooltip" data-placement="top" title="Consulta Estoque"
                v-if="options.btnArchive" @click="clickArchive()">
                    <i class="fa fa-archive fa-fw"></i>
                    <span v-if="options.btnArchiveLabel" class="ml-1">{{ options.btnArchiveLabel }}</span>
            </button>
            <button type="button" class="btn btn-outline-secondary btn-sm" style="margin-right: 5px"
                data-toggle="tooltip" data-placement="top" title="Visualizar mais detalhes"
                v-if="options.btnView" @click="clickView()">
                    <i class="fa fa-search fa-fw"></i>
            </button>
            <button type="button" class="btn btn-outline-secondary btn-sm" style="margin-right: 5px"
                data-toggle="tooltip" data-placement="top" title="Imprimir/PDF"
                v-if="options.btnPrint" @click="clickPrint()">
                    <i class="fa fa-print fa-fw"></i>
            </button>
            <button type="button" class="btn btn-outline-secondary btn-sm" style="margin-right: 5px"
                data-toggle="tooltip" data-placement="top" title="Faturar"
                v-if="faturar" @click="clickFaturar()">
                    <i class="fa fa-dollar fa-fw"></i>
            </button>
            <button type="button" class="btn btn-outline-secondary btn-sm" style="margin-right: 5px"
                data-toggle="tooltip" data-placement="top" title="Devolucao"
                v-if="devolucao" @click="clickDevolucao()">
                Devolução
                    <i class="fa fa-undo fa-fw"></i>
            </button>
            <div class="btn-group float-right" v-if="moreActions && moreActions.length > 0">
                <button class="btn btn-sm btn-outline-secondary dropdown-toggle" data-toggle="dropdown">Mais Ações <span class="caret"></span></button>
                <div class="dropdown-menu" aria-labelledby="btnGroupDrop1" style="z-index: 9999;">
                    <a class="dropdown-item" href="javascript:void(0)"
                        v-for="action in moreActions"
                        v-bind:key="action.action"
                        v-bind:title="action.title"
                        @click="clickAction(action.action, action)">{{ action.label }}</a>
                </div>
            </div>
        </div>
<!-- OPCOES PARA ITEM DO PEDIDO DE VENDA -->
        <div class="btn-group" v-if="options.barPedvIt">
            <button type="button" class="btn btn-outline-secondary btn-sm" style="margin-right: 5px"
                data-toggle="tooltip" data-placement="top" title="Alterar Item"
                v-if="!view" @click="clickEdit()">
                    <i class="fa fa-pencil fa-fw"></i>
            </button>
            <button type="button" class="btn btn-outline-secondary btn-sm" style="margin-right: 5px"
                data-toggle="tooltip" data-placement="top" title="Visualizar mais detalhes do item"
                @click="clickView()">
                    <i class="fa fa-search fa-fw"></i>
            </button>
            <button type="button" class="btn btn-outline-secondary btn-sm" style="margin-right: 5px"
                data-toggle="tooltip" data-placement="top" title="Excluir Item"
                v-if="!view" @click="clickDelete()">
                    <i class="fa fa-trash fa-fw"></i>
            </button>
            <!-- <button type="button" class="btn btn-outline-secondary btn-sm" style="margin-right: 5px"
                data-toggle="tooltip" data-placement="top" title="Cancelar Item"
                v-if="!view" @click="clickCancel()">
                    <i class="fa fa-ban fa-fw"></i>
            </button> -->
        </div>
<!-- OPCOES NOTA FISCAL -->
        <div class="btn-group" v-if="options.barNF">
            <button type="button" class="btn btn-outline-secondary btn-sm" style="margin-right: 5px"
                data-toggle="tooltip" data-placement="top" title="Alterar"
                v-if="edit" @click="clickEdit()">
                    <i class="fa fa-pencil fa-fw"></i>
            </button>
            <button type="button" class="btn btn-outline-secondary btn-sm" style="margin-right: 5px"
                data-toggle="tooltip" data-placement="top" title="Visualizar detalhes"
                v-if="view" @click="clickView()">
                    <i class="fa fa-search fa-fw"></i>
            </button>
            <button type="button" class="btn btn-outline-secondary btn-sm" style="margin-right: 5px"
                data-toggle="tooltip" data-placement="top" title="Enviar NF-e para SEFAZ"
                v-if="sefaz" @click="clickSend()">
                    <i class="fa fa-rss-square fa-fw"></i>
            </button>
            <button type="button" class="btn btn-outline-secondary btn-sm" style="margin-right: 5px"
                data-toggle="tooltip" data-placement="top" title="Gerar Danfe PDF"
                v-if="print" @click="clickPrint()">
                    <i class="fa fa-file-pdf-o fa-fw"></i>
            </button>
            <button type="button" class="btn btn-outline-secondary btn-sm" style="margin-right: 5px"
                data-toggle="tooltip" data-placement="top" title="Baixar XML da NF-e"
                v-if="xml" @click="clickXML()">xml
            </button>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        options: {},
        moreActions: '',
        obj: null,
    },

    data () {

        return {
            view: false,
            print: false,
            sefaz: false,
            xml: false,
            edit: false,
            email: false,
            faturar: false,
            devolucao: false,
        }

    },

    watch: {
        stnf: function () {
            this.updateButtons()
        },

        isView: function () {
            this.updateButtons()
        },
    },

    computed: {
        stnf: function () {
            return this.options.stnf
        },

        isView: function () {
            return this.options.isView
        },
    },

    methods: {

        clickEdit() {
            this.$emit('edit')
        },

        clickDelete() {
            this.$emit('delete')
        },

        clickArchive() {
            this.$emit('archive')
        },

        clickCancel() {
            this.$emit('cancel')
        },

        clickView() {
            this.$emit('view')
        },

        clickSend() {
            this.$emit('send')
        },

        clickEmail() {
            this.$emit('email')
        },

        clickPrint() {
            this.$emit('print')
        },

        clickFaturar() {
            this.$emit('faturar')
        },

        clickDevolucao() {
            this.$emit('devolucao')
        },


        clickXML() {
            this.$emit('xml')
        },

        clickAction(action, actionObj) {
            this.$emit('action', action, this.obj, actionObj)
        },

        updateButtons() {
            this.print = this.options.btnPrint
            this.faturar = this.options.btnFaturar
            this.devolucao = this.options.btnDevolucao

            if (this.options.barNF) {
                //BOTOES PARA NOTA FISCAL: habilita os botoes conforme o status da nf
                this.edit = ((this.options.stnf < '10' && this.options.stnf != '02') || this.options.stnf == '50')
                this.print = this.options.autoriza && (this.options.stnf == '10')
                this.email = this.options.autoriza && (this.options.stnf == '10')
                this.sefaz = this.options.autoriza && (this.options.stnf == '01' || this.options.stnf == '02' || this.options.stnf == '50')
                this.xml = (this.options.stnf == '10' || this.options.stnf >= '50' || this.options.chave)
                this.view = true
            } else if (this.options.barPedvIt) {
                //BARRA DE PEDIDO: habilita os botoes conforme o status do pedido
                this.view = this.isView || (this.options.stpedv != 'D' && this.options.stpedv != 'P')
                this.print = ((this.options.stpedv == 'P' || this.options.stpedv == 'F') && this.options.tppedv != 'R')
                this.email = ((this.options.stpedv == 'P' || this.options.stpedv == 'F') && this.options.tppedv != 'R')
            }

        }

    },

    destroyed(){
      this.$nextTick(function () {
              jQuery('[data-toggle="tooltip"]').tooltip('hide')
          })
    },

    created () {
        this.updateButtons()
    }

}
</script>






// WEBPACK FOOTER //
// src/components/bar-grid.vue